<template>
  <div class="timesheet-list">
    <div class="list-table__title">Timesheet</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="timesheets"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #head(select)>
        <label class="checkbox">
          <input
            @change="selectAll($event)"
            type="checkbox"
            :value="pager.current"
            v-model="selectedAllCheckForPages"
          >
        </label>
      </template>
      <template #cell(select)="timesheet">
        <label class="checkbox">
          <input
            :value="timesheet.item.tutor.id"
            type="checkbox"
            v-model="selectedTutorIds"
          >
        </label>
      </template>
      <template #head(tutor.id)="data">
        <div
          @click="sortByTutorId()"
          :class="sortDirection"
        >{{ data.label }}
        </div>
      </template>
      <template #cell(Detail)="timesheet">
        <div>
          <b-button
            pill
            variant="outline-secondary"
            :to="{name: 'TimesheetDetail', params: { tutorId: timesheet.item.tutor.id }}"
          >
            Detail
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Position } from '@/store/master/types';
import { Component, Prop, Vue } from 'vue-property-decorator'
import Pager from '@/components/parts/Pager.vue';
import { Moment } from 'moment'
import { Timesheet as TimesheetType, TimesheetConditions } from '@/store/timesheets/types';

@Component
export default class Timesheet extends Vue {
  @Prop({}) timesheets!: TimesheetType[]

  @Prop({}) pager!: Pager[]

  selectedTutorIds: string[] = []

  private selectedAllCheckForPages: number[] = []

  private sortDirection: 'asc'|'desc'|null = null

  private fields: Array<Object> = [
    {
      key: 'select',
      label: 'Select',
    },
    {
      key: 'tutor.id',
      label: 'Tutor ID',
    },
    {
      key: 'tutor.name',
      label: 'Tutor Name',
    },
    {
      key: 'date',
      label: 'Year/Month',
      formatter: (date: Moment): string => date.format('YYYY/MM'),
    },
    {
      key: 'tutor.position',
      label: 'Position',
      formatter: (position: Position): string => position.name,
    },
    {
      key: 'isConfirmed',
      label: 'Confirmed',
    },
    {
      key: 'Detail',
      thClass: 'head-detail',
    },
  ]

  private get conditions(): TimesheetConditions {
    return this.$store.state.timesheets.conditions
  }

  private get current(): number {
    return this.$store.state.timesheets.pager.current
  }

  private selectAll(event: {target: HTMLInputElement}) {
    const timesheets: string[] = this.timesheets.map((timesheet: any) => timesheet.tutor.id)
    _.pull(this.selectedTutorIds, ...timesheets)

    if (event.target.checked) {
      this.selectedTutorIds.push(...timesheets)
    }
  }

  private sortByTutorId() {
    const directions = ['asc', 'desc', null]
    const directionPosition = _.indexOf(directions, this.sortDirection)
    this.sortDirection = directions[(directionPosition + 1) % 3] as 'asc'|'desc'|null

    if (this.sortDirection) {
      this.$emit('sort', this.sortDirection)
      this.$store.dispatch('fetchTimesheets', {
        conditions: this.conditions,
        page: this.current,
        sortBy: { key: 'tutorId', direction: this.sortDirection },
      })
    }
  }
}
</script>

<style>
.timesheet-list .head-detail {
  width: 140px;
}

.timesheet-list .list-table .list-table__head {
  font-size: .8rem;
}

.timesheet-list .list-table .list-table__body td {
  font-size: .8rem;
  padding: 1rem;
}

.asc::after {
  margin-left:5px;
  content: "▼";
}

.desc::after {
  margin-left:5px;
  content: "▲";
}
</style>
